import { SITE_NAME, SITE_IMAGE, getSiteUrl, type ResolvedSeo } from "./seo";
import { articlesData } from "@/pages/article/articlesData";

export function buildSchemas(seo: ResolvedSeo, url: string): object[] {
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: getSiteUrl(),
    logo: SITE_IMAGE,
  };

  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: getSiteUrl(),
  };

  const schemas: object[] = [organization, website];

  if (seo.articleId && articlesData[seo.articleId]) {
    const article = articlesData[seo.articleId];

    schemas.push({
      "@context": "https://schema.org",
      "@type": "Article",
      headline: article.h1,
      description: article.metaDesc,
      image: [SITE_IMAGE],
      datePublished: article.lastUpdated,
      dateModified: article.lastUpdated,
      author: { "@type": "Organization", name: article.author },
      publisher: {
        "@type": "Organization",
        name: SITE_NAME,
        logo: { "@type": "ImageObject", url: SITE_IMAGE },
      },
      mainEntityOfPage: url,
    });

    if (article.faqs && article.faqs.length > 0) {
      schemas.push({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: article.faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      });
    }

    schemas.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: getSiteUrl() },
        { "@type": "ListItem", position: 2, name: article.h1, item: url },
      ],
    });
  } else {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: seo.title,
      description: seo.description,
      url,
    });
  }

  return schemas;
}